import React, { Fragment } from "react";

const HeaderText = () => (
  <Fragment>
    <div className="col-xs-12">
      <h1 className="header__text">Поиск дешевых авиабилетов</h1>
    </div>
    <div className="col-xs-12">
      <h2 className="header__subtext">
        Лучший способ купить авиабилеты дешево
      </h2>
    </div>
  </Fragment>
);

export default HeaderText;
